import sum from './sum'

const items = [
  {
    name: 'pacifiers',
    label: 'Pacifiers',
    description: 'Babies go through multiple pacifiers in the first year, anywhere from 12-24 of them, this will typically costs anywhere from $15-$50.',
    enabled: true,
    value: 25,
  },
  {
    name: 'bathTub',
    label: 'Bath tub',
    description: 'Baby bath tubs typically range anywhere from $15-$50 per tub.',
    enabled: true,
    value: 25,
  },
  {
    name: 'bibs',
    label: 'Bibs',
    description: "It's common to have up to 10-12 bibs in the first year, this can typically cost anywhere from $20-$50.",
    enabled: true,
    value: 25,
  },
  {
    name: 'wipes',
    label: 'Wipes',
    description: 'Baby wipes will typically range anywhere from $50-$200 in the first year.',
    enabled: true,
    value: 100,
  },
  {
    name: 'dishes',
    label: 'Dishes',
    description: 'Baby dishes (plates, cups, etc.) typically range anywhere from $15-$50.',
    enabled: true,
    value: 25,
  },
  {
    name: 'diaperBags',
    label: 'Diaper bags',
    description: 'Diaper bags typically range anywhere from $15-$50.',
    enabled: true,
    value: 25,
  },
  {
    name: 'toys',
    label: 'Toys',
    description: 'Bouncers, play sets, plushies, etc. will typically range anywhere from $150-$1000.',
    enabled: true,
    value: 300,
  },
  {
    name: 'subscriptions',
    label: 'Subscriptions',
    description: 'Entertainment, interactive games, etc. Subscriptions can range anywhere from $100-$300.',
    enabled: true,
    value: 150,
  },
]


export default {
  name: 'miscellaneous',
  label: 'Miscellaneous',
  enabled: false,
  value: sum(items),
  on: false,
  items,
}
